import { useState } from "react";
import { Card, CardTitle, CardBody, Row, Input, Button, Col, Label, FormGroup, FormText } from "reactstrap"
import { apiService } from "../../constants/ApiService";
import Loader from "../../layouts/loader/Loader";
import { useSelector } from "react-redux";

const PromoteStudentsFeeSlabs = () => {
    const[password,setPassword] = useState("");
    const[response,setResponse] = useState({});
    const[loading,setLoading] = useState(false);
    const sessionData = useSelector((state)=> state.sessionState);

    const callPromoteStudentsApi = async () => {
        setLoading(true);

        try {
            if(!password)
            {
                setResponse({message:"Password is required"});
              setLoading(false);

                return;
            }
            const queryParams = new URLSearchParams();
    
            if (password) queryParams.append("password", password);    
            if (sessionData) queryParams.append("session", sessionData.session_year);    
            
            const response = await apiService.get(`api/Admission/PromoteStudentsFeeSlab?${queryParams.toString()}`);
            //if (response.status === true) {
              setResponse(response);
              setLoading(false);

            //}
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);

        }
    };

    
    return (
        <>
        {loading && <Loader/>}        
            <Col lg='12'>
                <Card className='card-box height-100-p pd-20 mb-20'>
                    <CardTitle tag='h6' className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'>
                        <div className='d-flex align-items-center'>
                            <i className='bi bi-card-text mr-2'></i>
                            Promote all students fee slabs 
                        </div>
                    </CardTitle>

                    <CardBody>
                       
                        <Row className="text-center justify-content-center m-5">
                          <Col md="12"> {response.message && (
                          <FormText color='danger'>
                            {response.message}
                          </FormText>
                        )}</Col>
                            <Col md="4">
                           
                                <FormGroup>
                                    <Label>Enter the Password:</Label>
                                    <Input
                                    onChange={(e)=>{setPassword(e.target.value)}}
                                    type="password"
                                    name="password"
                                    className="form-control"
                                    required
                                    />
                                </FormGroup>
                               
                                <Button className="btn btn-success col-12" onClick={callPromoteStudentsApi}>Verify & Execute</Button>

                            </Col>

                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </>
    )
}

export default PromoteStudentsFeeSlabs;